import script from "./CartMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CartMenu.vue?vue&type=style&index=0&id=35209d31&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35209d31"]])

export default __exports__